import { getCalendarProviderAccountForType } from '../selectors/calendarProviderAccountsSelectors';
import { getCalendarsForCalendarProviderAccount } from '../services/getCalendarsForCalendarProviderAccount';
import type { GetCalendarsForCalendarProviderAccountErrorResponse } from '../types/GetCalendarsForCalendarProviderAccountErrorResponse';
import type { CalendarProviderAccount } from '../store/schema/CalendarProviderAccount';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';
import {
    loadCalendarsForCalendarProvider,
    calendarsForCalendarProviderLoaded,
    errorInLoadingCalendarsForCalendarProvider,
    calendarProviderAccountUnauthorized,
} from '../actions/publicActions';
import { assertNever } from 'owa-assert';

orchestrator(loadCalendarsForCalendarProvider, async actionMessage => {
    const { providerType } = actionMessage;
    const providerAccount = getCalendarProviderAccountForType(providerType);

    try {
        if (providerAccount) {
            const returnVal = await getCalendarsForCalendarProviderAccount(providerAccount.id);
            if (returnVal.isError === false) {
                const {
                    response: { calendars },
                } = returnVal;

                calendarsForCalendarProviderLoaded(providerType, providerAccount.id, calendars);
            } else {
                handleKnownError(returnVal.response, providerAccount);
                errorInLoadingCalendarsForCalendarProvider(providerType);
            }
        }
    } catch (error) {
        trace.warn(`Error in getting calendars for calendar provider: ${error.toString()}`);
        errorInLoadingCalendarsForCalendarProvider(providerType);
    }
});

function handleKnownError(
    response: GetCalendarsForCalendarProviderAccountErrorResponse,
    providerAccount: CalendarProviderAccount
) {
    const { errorCode } = response;

    switch (errorCode) {
        case 'CalendarProviderAccountUnauthorized':
            calendarProviderAccountUnauthorized(providerAccount);
            break;
        default:
            assertNever(errorCode);
    }
}
